import React from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'
import { defineMessages, useIntl } from 'react-intl'

import left from 'components/designSystem/svg/keyboard/left.svg'
import right from 'components/designSystem/svg/keyboard/right.svg'
import space from 'components/designSystem/svg/keyboard/space.svg'

import { keyboardViewHeight } from './constant'

const messages = defineMessages({
  like: {
    id: 'photo_rating.navigation.like',
    defaultMessage: 'Нравится',
  },
  dislike: {
    id: 'dating_profile.button.skip',
    defaultMessage: 'Пропустить',
  },
  space: {
    id: 'photo_rating.navigation.flip_through_photos',
    defaultMessage: 'Листать фото',
  },
})

export const KeyboardView = () => {
  const intl = useIntl()

  return (
    <Parent>
      <div data-name="keyboard-dislike-item">
        <img
          src={left}
          width={24}
          height={24}
          title={intl.formatMessage(messages.dislike)}
          className={cx(baseCss)}
        />
      </div>
      <div data-name="keyboard-next-item">
        <img
          src={space}
          width={64}
          height={24}
          title={intl.formatMessage(messages.space)}
          className={cx(baseCss)}
        />
      </div>
      <div data-name="keyboard-like-item">
        <img
          src={right}
          width={24}
          height={24}
          title={intl.formatMessage(messages.like)}
          className={cx(baseCss)}
        />
      </div>
    </Parent>
  )
}

const Parent = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: var(--spacing-16px);
  grid-gap: var(--spacing-16px);
  max-width: fit-content;
  height: ${keyboardViewHeight}px;
  direction: ltr;
  user-select: none;
`

const baseCss = css`
  vertical-align: top;
`
